import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  orgSetting: null,
  orgSettingLoading: false,
};

const orgSettingSlice = createSlice({
  name: 'orgSettingSlice',
  initialState,
  reducers: {
    getOrgSettingSlice: (state, { payload }) => {
      state.orgSetting = payload;
    },
    orgSettingLoadingSlice: (state, { payload }) => {
      state.orgSettingLoading = payload;
    },
  },
});

const { actions, reducer } = orgSettingSlice;

export const { getOrgSettingSlice, orgSettingLoadingSlice } = actions;

export default reducer;
